export default function AppSection() {
  return (
    <section id="app" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
              移动端入口
            </h2>
            <p className="text-sm text-foreground-600 max-w-[480px] mx-auto lg:mx-0 leading-relaxed mb-6">
              妖精动漫网完美适配手机浏览器，无需下载App即可享受流畅的下拉式阅读体验。打开手机浏览器访问妖精动漫官网入口，随时随地畅读韩漫、日漫、国漫全集。收藏、追更、阅读，一部手机全搞定。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-white font-semibold rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors text-center text-sm"
              >
                <i className="ri-smartphone-line mr-1.5"></i>
                手机端访问
              </a>
              <span className="text-sm text-foreground-500">或直接在浏览器输入妖精动漫网址</span>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[300px] lg:max-w-[320px]">
            <div className="relative w-full aspect-[9/16] rounded-2xl overflow-hidden bg-background-200 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20a%20colorful%20comic%20page%20on%20screen%2C%20showing%20vertical%20scroll%20reading%20mode%20with%20manga%20panels%2C%20minimal%20device%20frame%2C%20soft%20warm%20background%20gradient%2C%20clean%20and%20modern%20UI%20design%2C%20professional%20product%20mockup%20style%20with%20soft%20shadows%2C%20perfect%20for%20a%20manga%20reading%20platform%20mobile%20showcase&width=400&height=711&seq=app-mockup-01&orientation=portrait"
                alt="妖精动漫移动端 - 手机看漫画"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}